import { VueConstructor } from "vue";
import { EntityListProvider } from "~shared/classes/entity-list.provider";
import { EntityListSearchBuilder } from "~shared/builders/entity-list-search.builder";
import { EntityListPaginationBuilder } from "~shared/builders/entity-list-pagination.builder";
import { EntityListBuilder } from "~shared/builders/entity-list.builder";
import IdentityProvidersListView from "@/modules/identity-providers/components/IdentityProvidersListView.vue";
import { IdentityProvidersListProvider } from "@/modules/identity-providers/providers/identity-providers-list.provider";

export class IdentityProvidersDirector {
  public static createIndexList(): VueConstructor<EntityListProvider> {
    const IdentityProvidersListSearch = new EntityListSearchBuilder().withPlaceholder("Search for value").build();
    const IdentityProvidersListPagination = new EntityListPaginationBuilder().build();

    return new EntityListBuilder()
      .withPagination(IdentityProvidersListPagination)
      .withListView(IdentityProvidersListView)
      .withSearch(IdentityProvidersListSearch)
      .withProvider(IdentityProvidersListProvider)
      .build();
  }
}
